import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationBolos.ts
function useLocationBolos(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationBolosList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.locationId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationBolos };

//# sourceMappingURL=useLocationBolos.js.map